export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Операцияны қайталау"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Операция тарихы"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шоттар тізімі"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белгісіз қате"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Токендер тізімі"])}
}